"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetAllFilters = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
const State = __importStar(require("../../store/state"));
const useResetAllFilters = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const resetAllFilters = (0, react_1.useCallback)(() => {
        dispatch((0, store_1.refinementsSetFilter)(State.AvailableRefinementType.All));
        dispatch((0, store_1.productsSetIncludedCategoriesIds)([]));
        dispatch((0, store_1.productsSetExcludedCategoriesIds)([]));
        dispatch((0, store_1.productsClearIncludedTaxonomyClassIds)());
        dispatch((0, store_1.productsClearExcludedTaxonomyClassIds)());
        dispatch((0, store_1.productsSetIncludedAttributesIds)([]));
        dispatch((0, store_1.productsSetExcludedAttributesIds)([]));
        dispatch((0, store_1.productsSetFilterActive)(State.ProductFilterActiveTypes.All));
        dispatch((0, store_1.productsSetFilterOperator)(State.ProductFilterOperatorType.Or));
        dispatch((0, store_1.facetNavigationSetOpenAttributes)({}));
        dispatch((0, store_1.facetNavigationSetOpenCategories)({}));
        dispatch((0, store_1.facetNavigationSetOpenTaxonomyClasses)(false));
        dispatch((0, store_1.facetNavigationSetSearchTerm)(''));
    }, [dispatch]);
    return { resetAllFilters };
};
exports.useResetAllFilters = useResetAllFilters;
exports.default = exports.useResetAllFilters;
